import { render, staticRenderFns } from "./info-edit.vue?vue&type=template&id=dbec47f8&"
import script from "./info-edit.vue?vue&type=script&lang=js&"
export * from "./info-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports